import React, { Component } from 'react';
import "./notification.scss"
import Utils, {secondsToMiliseconds} from '../../../utils/Utils';
import store from '../../../store';
import { hideNotification } from '../../../actions/notification';

export const DEFAULT_TIME_TO_HIDE = 6

class ToastNotification extends Component{
    constructor(props){
        super(props)
        this.refTimeOut = null
    }

    startHideTimeout = () => {
        if (this.refTimeOut) {
            clearTimeout(this.refTimeOut)
        }

        const timeToHide = this.props.displayDurationSeconds || Utils.displayDurationSeconds()
        this.refTimeOut = setTimeout(() => {
            store.dispatch(hideNotification())
        }, secondsToMiliseconds(timeToHide))
    }

    componentDidMount(){
        this.startHideTimeout()
    }

    componentDidUpdate() {    
        this.startHideTimeout()
    }

    componentWillUnmount() {
        if (this.refTimeOut) {
            clearTimeout(this.refTimeOut)
        }
    }

    render(){
        const { title, text, img, imgStyles } = this.props
        const { title: titleContentDesc = '', text: textContentDesc = '', img: imgContentDesc = '' } = this.props.contentDesc || {};
        return(
            <div className='notification_container'>
                <div className='notification_content_img_container'>
                    <div className='notification_content_img'>
                    <img className='notification_img'
                        data-automation-content-desc={imgContentDesc} src={img} style={imgStyles}/>
                    </div>
                </div>
             
                <div className='notification_content_text'>
                    {/* STVCL-172 (corrección): topes confirmados contra Figma (node
                        290:3590, "TvAlert") -- título máximo 69 caracteres, cuerpo
                        máximo 149 caracteres / 2 líneas. */}
                    <p  className='notification_title'  data-automation-content-desc = {titleContentDesc}>{Utils.cutPlayerString(title,69)}</p>
                    {text && <p className='notification_text'  data-automation-content-desc = {textContentDesc}>{Utils.cutPlayerString(text, 149)}</p>}
                </div>   
            </div>
        )
    }
}

export default ToastNotification



// WEBPACK FOOTER //
// ./src/components/Notification/toasNotification/ToasNotification.jsx